import React from 'react';
import PageWrapper from '.';

const wrapPage = (Component: React.ComponentType, hideFooter?: boolean) => {
  return () => (
    <PageWrapper hideFooter={hideFooter}>
      <Component />
    </PageWrapper>
  );
};

export default wrapPage;
